import { getContext, Symbols } from 'choerodon-ui/shared';
import { getConfig, getCustomizable, getPrefixCls, getProPrefixCls } from '../configure/utils';
import { getTooltip, getTooltipTheme, getTooltipPlacement } from '../_util/TooltipUtils';
const ConfigContext = getContext(Symbols.ConfigContext, {
    getConfig,
    getPrefixCls,
    getProPrefixCls,
    getCustomizable,
    getTooltip,
    getTooltipTheme,
    getTooltipPlacement,
});
export default ConfigContext;
